import React from "react";

import AuthLayout from "../components/AuthLayout";
import DefaultLayout from "../components/DefaultLayout";

const Login = React.lazy(() => import("./Login"));
const Portal = React.lazy(() => import("./Portal"));
const AttendanceHistory = React.lazy(
  () => import("./Attendance/AttendanceHistory")
);
const LeaveTicketHistory = React.lazy(
  () => import("./Attendance/LeaveTicketHistory")
);
const RequestCancelTicketHistory = React.lazy(
  () => import("./Attendance/RequestCancelTicketHistory")
);
const RequestLeaveStatHistory = React.lazy(
  () => import("./Attendance/RequestLeaveStatHistory")
);
const DailyAttendance = React.lazy(
  () => import("./Attendance/DailyAttendance")
);
const LeaveTicketManagement = React.lazy(
  () => import("./Attendance/LeaveTicketManagement")
);
const LeaveTicketCancelRequest = React.lazy(
  () => import("./Attendance/LeaveTicketCancelRequest")
);
const LeaveStatRequest = React.lazy(
  () => import("./Attendance/LeaveStatRequest")
);
const HolidayManager = React.lazy(() => import("./Attendance/HolidayManager"));
const AttendanceConfig = React.lazy(
  () => import("./Attendance/AttendanceConfig")
);
const AttendanceReport = React.lazy(
  () => import("./Attendance/AttendanceReport")
);
const Profile = React.lazy(() => import("./UserManager/Profile"));
const EditUser = React.lazy(() => import("./UserManager/EditUser"));
const UserList = React.lazy(() => import("./UserManager/UserList"));
const DepartmentList = React.lazy(() => import("./UserManager/DepartmentList"));
const LIFF = React.lazy(() => import("./LIFF"));
const Telegram = React.lazy(() => import("./TelegramApp"));
const NotFound = React.lazy(() => import("./NotFound"));
const UserTel = React.lazy(() => import("./UserData/UserTel"));

const routes = [
  {
    path: "",
    element: AuthLayout,
    children: [{ path: "", element: <Login /> }],
  },
  { path: "liff", element: <LIFF /> },
  { path: "telegram", element: <Telegram /> },
  { path: "*", element: <NotFound /> },
  {
    path: "",
    element: DefaultLayout,
    children: [
      { path: "portal", element: <Portal /> },
      { path: "attendance/history", element: <AttendanceHistory /> },
      { path: "attendance/ticket/history", element: <LeaveTicketHistory /> },
      {
        path: "attendance/ticket/cancel/history",
        element: <RequestCancelTicketHistory />,
        exact: true,
      },
      {
        path: "attendance/leave/stat/history",
        element: <RequestLeaveStatHistory />,
      },
      {
        path: "attendance/daily_attendance",
        element: <DailyAttendance />,
      },
      {
        path: "attendance/leave/manager",
        element: <LeaveTicketManagement />,
      },
      {
        path: "attendance/ticket/cancel/manager",
        element: <LeaveTicketCancelRequest />,
      },
      {
        path: "attendance/leave/stat/manager",
        element: <LeaveStatRequest />,
      },
      {
        path: "holiday/manager",
        element: <HolidayManager />,
      },
      {
        path: "attendance/setting",
        element: <AttendanceConfig />,
      },
      {
        path: "attendance/report",
        element: <AttendanceReport />,
      },
      {
        path: "profile/edit",
        element: <Profile />,
      },
      {
        path: "user/edit/:id",
        element: <EditUser />,
      },
      {
        path: "user/all",
        element: <UserList />,
      },
      {
        path: "department/all",
        element: <DepartmentList />,
      },
      {
        path: "user/tel",
        element: <UserTel />,
      },
    ],
  },
];

export default routes;
